/** Where a stránka is read. */
export function customPagePath(slug: string): string {
  return `/stranky/${slug}`;
}

/**
 * A title turned into an address the server accepts
 * (`^[a-z0-9]+(-[a-z0-9]+)*$`): lowercase, diacritics dropped, every other
 * run of characters a single dash. „Pokyny pro vedoucí 2026" →
 * „pokyny-pro-vedouci-2026".
 */
export function slugify(title: string): string {
  return title
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 100)
    .replace(/-+$/, "");
}

const CMF_TAG = /<\/?cmf-[a-z]+(?:\s[^>]*)?>/g;

/**
 * Puts every <cmf-…> tag on a line of its own, blank lines around it, so
 * Markdown always reads it as an HTML block and the text between as
 * Markdown. Left to Markdown, a closing tag right under a line of text is
 * folded into that paragraph („…text</cmf-alert></p>"), and a browser
 * IGNORES an end tag that arrives inside an open <p>: the component never
 * closes and swallows the rest of the page. jsdom's parser forgives it, so
 * no unit test sees that; only a browser does. A tag written inside a code
 * block is moved the same way.
 *
 * Text inside a tag loses its common indentation: whoever nests HTML out of
 * habit indents it, and Markdown reads four leading spaces as a code block.
 */
export function isolateTags(markdown: string): string {
  // split() with a capture group: text at even indexes, tags at odd ones.
  const parts = markdown.split(new RegExp(`(${CMF_TAG.source})`));
  let depth = 0;
  return parts
    .map((part, i) => {
      if (i % 2 === 1) {
        depth = Math.max(0, depth + (part.startsWith("</") ? -1 : 1));
        return `\n\n${part}\n\n`;
      }
      return depth > 0 ? dedent(part) : part;
    })
    .join("");
}

function dedent(text: string): string {
  const lines = text.split("\n");
  const indents = lines.filter((l) => l.trim() !== "").map((l) => l.length - l.trimStart().length);
  const cut = indents.length > 0 ? Math.min(...indents) : 0;
  return cut === 0 ? text : lines.map((l) => l.slice(Math.min(cut, l.length - l.trimStart().length))).join("\n");
}
